"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var react_1 = __importDefault(require("react"));

var index_1 = __importDefault(require("./index"));

var MultipleValueFilterItem =
/** @class */
function (_super) {
  __extends(MultipleValueFilterItem, _super);

  function MultipleValueFilterItem() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.validOperators = ['in'];

    _this.selectAll = function (e) {
      var selectedValues = [];

      if (e.target.checked) {
        // For some reason TSC compiler thinks `item.id` can be React.Text...
        selectedValues = _this.values.map(function (item) {
          return lodash_1.toString(item.id);
        });
      }

      _this.setState({
        selectedValues: selectedValues
      });
    };

    _this.checkValue = function (e, value) {
      var add = e.target.checked;
      var selectedValues = _this.state.selectedValues; // Convert to array if it is not, unfortunatelly
      // this is not for TS :(

      var arr = selectedValues;

      if (!arr) {
        arr = [];
      } else if (!lodash_1.isArray(arr)) {
        arr = [selectedValues];
      }

      if (add) {
        arr.push(value);
      } else {
        arr.splice(arr.indexOf(value), 1);
      }

      _this.setState({
        selectedValues: arr.length ? arr : undefined
      });
    };

    _this.renderSelect = function () {
      var localization = _this.props.localization;
      var _a = _this.state,
          selectedValues = _a.selectedValues,
          filter = _a.filter;
      var select;

      if (filter.length > 0) {
        select = react_1.default.createElement("strong", null, localization.foundResults.replace('%COUNT', "" + filter.length));
      } else {
        select = react_1.default.createElement("label", {
          key: _this.props.id + "_select_all"
        }, react_1.default.createElement("input", {
          type: "checkbox",
          checked: lodash_1.castArray(selectedValues).length === Object.keys(_this.values).length,
          onChange: _this.selectAll
        }), react_1.default.createElement("strong", null, localization.selectAll));
      }

      return select;
    };

    _this.renderRows = function () {
      var _a = _this.state,
          selectedValues = _a.selectedValues,
          filter = _a.filter;
      return _this.values.map(function (item) {
        var key = lodash_1.toString(item.id);
        var value = item.name;
        var isChecked = lodash_1.castArray(selectedValues).indexOf(key) >= 0;

        if (item.name.toLocaleLowerCase().indexOf(filter.toLocaleLowerCase()) >= 0) {
          var handler = function handler(e) {
            _this.checkValue(e, key);
          };

          return react_1.default.createElement("label", {
            key: "option_" + item.id + "_" + value.replace(/ /g, '_'),
            className: "option"
          }, react_1.default.createElement("input", {
            type: "checkbox",
            checked: isChecked,
            onChange: handler
          }), react_1.default.createElement("span", {
            className: "text"
          }, value));
        }
      });
    };

    return _this;
  }

  return MultipleValueFilterItem;
}(index_1.default);

exports.default = MultipleValueFilterItem;